import React from 'react';
import AssignmentReturnedOutlinedIcon from '@mui/icons-material/AssignmentReturnedOutlined';
import AddTaskOutlinedIcon from '@mui/icons-material/AddTaskOutlined';
import UnsubscribeOutlinedIcon from '@mui/icons-material/UnsubscribeOutlined';

export interface CaseManagementData {
  casesOut: number;
  casesComplete: number;
  casesRejected: number;
  rejectionRatePercent: number;
}

interface CaseManagementContentProps {
  data: CaseManagementData;
}

const CaseManagementContent: React.FC<CaseManagementContentProps> = ({ data }) => {
  const { casesOut, casesComplete, casesRejected, rejectionRatePercent } = data;

  return (
    <div className="overview-case-management">
      <div className="overview-case-tile">
        <div className="overview-case-tile__value">
          <AssignmentReturnedOutlinedIcon className="overview-case-tile__icon" />
          {casesOut}
        </div>
        <div className="overview-case-tile__label">Cases Out</div>
      </div>
      <div className="overview-case-tile">
        <div className="overview-case-tile__value">
          <AddTaskOutlinedIcon className="overview-case-tile__icon" />
          {casesComplete}
        </div>
        <div className="overview-case-tile__label">Cases Complete</div>
      </div>
      <div className="overview-case-tile overview-case-tile--grow">
        <div className="overview-case-tile__value">
          <UnsubscribeOutlinedIcon className="overview-case-tile__icon" />
          {casesRejected}
          <span className="overview-case-tile__rate">({rejectionRatePercent}%)</span>
        </div>
        <div className="overview-case-tile__label">Cases Rejected</div>
      </div>
    </div>
  );
};

export default CaseManagementContent;
